__turbopack_context__.v({
  "qr-code": "QRCode-module-scss-module__B9WhDa__qr-code",
  "qr-code-border-svg": "QRCode-module-scss-module__B9WhDa__qr-code-border-svg",
  "qr-code-canvas": "QRCode-module-scss-module__B9WhDa__qr-code-canvas",
});
